import React from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react';

export default function Title({ ecmContent }) {
  return <HeadingText>{ecmContent}</HeadingText>;
}

Title.propTypes = { ecmContent: PropTypes.object.isRequired };
